import { ScoringPanelistsManagerReadModel } from "@Evaluation/AlternativesSurveys/Domain/readmodels";

export class ScoringPanelistsManagerViewModel
{
    opened: boolean = false;

    workspaceId: number;
    projectId: number;

    surveyId: number | null = null;
    data: ScoringPanelistsManagerReadModel | null = null;

    constructor(workspaceId: number, projectId: number)
    {
        this.workspaceId = workspaceId;
        this.projectId = projectId;
    }

    show(surveyId: number)
    {
        this.surveyId = surveyId;
        this.data = null;

        this.opened = true;
    }

    close()
    {
        this.opened = false;

        this.surveyId = null;
        this.data = null;
    }

    setData(data: ScoringPanelistsManagerReadModel)
    {
        this.data = data;
    }

    setIncluded(projectUserId: number)
    {
        const pu = this.data?.ProjectUsers.find(a => a.ProjectUserId === projectUserId);

        if (pu)
        {
            pu.Included = true;
        }
    }
}